import { Autocomplete, FormControl, FormLabel, TextField } from '@mui/material';

type Props = {
  label?: string;
  value: string;
  options?: any[];
  fullWidth?: boolean;
  required?: boolean;
  disabled?: boolean;
  autoFocus?: boolean;
  error?: string;
  onChange: (value: string) => void;
};

const SelectGrouped = ({
  label,
  value = '',
  options = [],
  fullWidth = true,
  required,
  disabled,
  error,
  onChange,
}: Props) => {
  return (
    <FormControl variant="standard" fullWidth={fullWidth} sx={{ marginTop: 0 }}>
      {label && <FormLabel required={required}>{label}</FormLabel>}
      <Autocomplete
        value={value}
        options={options}
        groupBy={(option) => option.eventType}
        disabled={disabled}
        onChange={(event: any, newValue: any) => {
          onChange(newValue);
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label={''}
            fullWidth={fullWidth}
            margin="dense"
            required={required}
            size="small"
            error={error !== undefined && error !== ''}
            helperText={error}
            disabled={disabled}
            sx={{ marginTop: 0, padding: 0 }}
          />
        )}
      />
    </FormControl>
  );
};

export default SelectGrouped;
